import React from 'react';

/** Renders **bold** segments of a string as emphasised text. */
export const Rich: React.FC<{ text: string }> = ({ text }) => (
  <>
    {text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
      part.startsWith('**') ? (
        <strong key={i} className="font-medium text-fg">
          {part.slice(2, -2)}
        </strong>
      ) : (
        part
      )
    )}
  </>
);

export const Chip: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="rounded-md border border-ink-700 bg-ink-800/80 px-2 py-0.5 font-mono text-[11px] text-fg-muted">
    {children}
  </span>
);

export const Eyebrow: React.FC<{ index: string; children: React.ReactNode }> = ({ index, children }) => (
  <span className="font-mono text-xs uppercase tracking-[0.2em] text-fg-faint">
    <span className="text-accent">{index}</span> / {children}
  </span>
);

interface SectionProps {
  id: string;
  index: string;
  eyebrow: string;
  title: React.ReactNode;
  children: React.ReactNode;
}

export const Section: React.FC<SectionProps> = ({ id, index, eyebrow, title, children }) => (
  <section id={id} className="scroll-mt-20 border-t border-ink-700 py-20 sm:py-28">
    <div className="reveal mb-12 flex min-w-0 flex-col gap-4 sm:mb-16">
      <Eyebrow index={index}>{eyebrow}</Eyebrow>
      <h2 className="font-serif text-[2.75rem] leading-[1.02] tracking-tight text-fg sm:text-6xl">{title}</h2>
    </div>
    {children}
  </section>
);
